import React from "react";
import {
    Dropdown,
    Icon,
    Menu,
} from "antd";
import {Link} from "react-router-dom";

import i18n from "../../i18n";

function hasActivePath(item, currentPath) {
    return (
        Array.isArray(item.links) &&
        item.links.includes(currentPath)
    );
}

function DesktopNavigationItem({
                                   item,
                                   currentPath,
                                   onNavigate,
                               }) {
    if (item.isDropdown && Array.isArray(item.subItems)) {
        const activeSubItem = item.subItems.find(
            (subItem) =>
                Array.isArray(subItem.links) &&
                subItem.links.includes(currentPath)
        );

        const dropdownMenu = (
            <Menu
                className="header-dropdown-menu nav-dropdown-menu"
                selectedKeys={
                    activeSubItem
                        ? [activeSubItem.links[0]]
                        : []
                }
            >
                {item.subItems.map((subItem) => {
                    const path = subItem.links[0];

                    return (
                        <Menu.Item key={path}>
                            <Link
                                to={path}
                                onClick={() => onNavigate(path)}
                            >
                                {i18n.t(
                                    `main.header.menu.${subItem.langKey}`
                                )}
                            </Link>
                        </Menu.Item>
                    );
                })}
            </Menu>
        );

        return (
            <li
                className={`nav-dropdown-item${
                    activeSubItem ? " active" : ""
                }`}
            >
                <Dropdown
                    overlay={dropdownMenu}
                    trigger={["hover", "click"]}
                    placement="bottomLeft"
                    mouseEnterDelay={0.1}
                    mouseLeaveDelay={0.1}
                >
                    <button
                        className="nav-dropdown-trigger"
                        type="button"
                        aria-haspopup="menu"
                    >
                        {i18n.t(
                            `main.header.menu.${item.langKey}`
                        )}

                        <Icon
                            type="down"
                            className="nav-dropdown-icon"
                        />
                    </button>
                </Dropdown>
            </li>
        );
    }

    const path = Array.isArray(item.links)
        ? item.links[0]
        : null;

    if (!path) {
        return null;
    }

    return (
        <li className={hasActivePath(item, currentPath) ? "active" : ""}>
            <Link
                to={path}
                onClick={() => onNavigate(path)}
            >
                {i18n.t(
                    `main.header.menu.${item.langKey}`
                )}
            </Link>
        </li>
    );
}

export default function DesktopNavigation({
                                              items = [],
                                              currentPath,
                                              onNavigate,
                                          }) {
    return (
        <div className="head-nav">
            <ul>
                {items.map((item, index) => (
                    <DesktopNavigationItem
                        key={`${item.langKey}-${index}`}
                        item={item}
                        currentPath={currentPath}
                        onNavigate={onNavigate}
                    />
                ))}
            </ul>
        </div>
    );
}